import { RouteStatus } from '../domain/route/RouteStatus';

export const ROUTE_STATUS = {
  notStarted: `not_started`,
  inTransit: `in_transit`,
  finished: `finished`,
} as Record<string, RouteStatus>;

export const ROUTE_END_LOCATION = `endLocation`;
export const ROUTE_START_LOCATION = `startLocation`;

export const ROUTE_STOPS_BLACKLIST: string[] = [];
